<style>
@import "@/assets/css/custom.css";
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Vodafone ICCID Details" />

		<div class="container-fluid">
			<div class="card">
				<div class="card-body">
					<div class="row mb-3">
						<div class="col-12">
							<a href="#" @click.prevent="$router.push({ name: 'requested_devices' })" class="btn btn-primary float-end">
								<i class="bx bx-chevrons-left"></i> Back
							</a>
						</div>
					</div>

					<div v-if="deviceImei || deviceIccid" class="row mb-4">
						<div class="col-md-12">
							<div class="card bg-info text-white">
								<div class="card-body">
									<h5 class="card-title mb-3">Device Information</h5>
									<div class="row">
										<div class="col-md-4" v-if="deviceImei">
											<strong>IMEI:</strong> {{ deviceImei }}
										</div>
										<div class="col-md-4" v-if="deviceIccid">
											<strong>ICCID:</strong> {{ deviceIccid }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="loading" class="text-center py-5">
						<div class="spinner-border text-primary" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</div>

					<div v-else-if="error" class="alert alert-danger">{{ error }}</div>

					<div v-else-if="details" class="table-responsive product-table">
						<table class="display table table-bordered">
							<tbody>
								<tr>
									<th style="width: 35%">ICCID</th>
									<td>{{ details.iccid || "—" }}</td>
								</tr>
								<tr>
									<th>Primary TSP Name</th>
									<td>{{ details.Primary_TSP_Name || "—" }}</td>
								</tr>
								<tr>
									<th>Fallback TSP Name</th>
									<td>{{ details.Fallback_TSP_Name || "—" }}</td>
								</tr>
								<tr>
									<th>Primary TSP MSISDN</th>
									<td>{{ details.Primary_TSP_MSISDN || "—" }}</td>
								</tr>
								<tr>
									<th>Fallback TSP MSISDN</th>
									<td>{{ details.Fallback_TSP_MSISDN || "—" }}</td>
								</tr>
								<tr>
									<th>Primary TSP Validity</th>
									<td>{{ details.Primary_TSP_Validity ? $filters.formatDate(details.Primary_TSP_Validity) : "—" }}</td>
								</tr>
								<tr>
									<th>Fallback TSP Validity</th>
									<td>{{ details.Fallback_TSP_Validity ? $filters.formatDate(details.Fallback_TSP_Validity) : "—" }}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div v-if="deviceExpirationtime" class="mt-4 mb-3">
						<strong>Device Management Expiry:</strong>
						{{ $filters.formatDateTime(deviceExpirationtime) }}
					</div>

					<div v-if="details" class="mt-4">
						<h6 class="border-bottom pb-2 mb-3">Update device validity</h6>
						<form @submit.prevent="submitUpdateExpiry">
							<div class="row">
								<div class="col-md-4 form-group">
									<label class="control-label" for="expiryDateInput">Expiry date<span class="text-danger">*</span></label>
									<input
										id="expiryDateInput"
										type="date"
										class="form-control"
										v-model="expiryDate"
										:class="{ 'is-invalid': errors.expiry_date }"
									/>
									<div v-if="errors.expiry_date" class="invalid-feedback">{{ errors.expiry_date }}</div>
								</div>
							</div>
							<button type="submit" class="btn btn-warning mt-3" :disabled="expirySubmitting">
								Update Validity
							</button>
						</form>
					</div>

					<!-- <div v-if="details && showCompleteAction" class="mt-4">
						<button type="button" class="btn btn-primary" @click="markAsRechargeCompleted" :disabled="completing">
							Mark As Recharge Completed
						</button>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "IccidDetails",

	data() {
		return {
			token: "",
			loading: false,
			completing: false,
			error: "",
			details: null,
			deviceRenewalId: "",
			deviceIccid: "",
			deviceImei: "",
			deviceExpirationtime: "",
			renewalType: "",
			expiryDate: "",
			expirySubmitting: false,
			errors: {},
		};
	},

	computed: {
		showCompleteAction() {
			return String(this.renewalType) !== "5";
		},
	},

	created() {
		this.deviceRenewalId = String(this.$route.query.device_id || this.$route.params.device_id || "").trim();
		this.deviceIccid = String(this.$route.query.iccid || "").trim();
		this.deviceImei = String(this.$route.query.imei || "").trim();
		this.deviceExpirationtime = this.readExpirationtimeFromRoute();
		this.renewalType = String(this.$route.query.renewal_type || "").trim();

		if (!this.deviceIccid) {
			this.error = "ICCID is required";
			return;
		}

		this.fetchIccidDetails();
	},

	methods: {
		readExpirationtimeFromRoute() {
			const rawQuery = this.$route.query.expirationtime;
			if (rawQuery) {
				try {
					return decodeURIComponent(String(rawQuery)).trim();
				} catch {
					return String(rawQuery).trim();
				}
			}
			const fromState = history.state?.expirationtime;
			return fromState ? String(fromState).trim() : "";
		},

		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					return;
				}
			}
			this.$swal("", "Session expired, please login again", "error");
			this.$router.push({ name: "login" });
		},

		fetchIccidDetails() {
			this.getToken();
			this.loading = true;
			this.error = "";
			this.$axios
				.get("/staffs/iccidDetails", {
					params: { iccid: this.deviceIccid },
					headers: { Authorization: "Bearer " + this.token },
				})
				.then((res) => {
					const ok = res.data?.status === true || res.data?.status === "true";
					if (ok && res.data?.data) {
						this.details = res.data.data;
						const primaryValidity = res.data.data.Primary_TSP_Validity;
						if (primaryValidity && !this.expiryDate) {
							this.expiryDate = String(primaryValidity).slice(0, 10);
						}
					} else {
						this.error = res.data?.message || "Failed to fetch ICCID details";
					}
				})
				.catch((err) => {
					this.error = err?.response?.data?.message || "Something went wrong";
				})
				.finally(() => {
					this.loading = false;
				});
		},

		markAsRechargeCompleted() {
			if (!this.deviceRenewalId) {
				this.$swal("", "Device renewal ID is missing", "error");
				return;
			}
			this.$swal({
				icon: "warning",
				title: "Confirm",
				text: "Are you sure you want to mark as recharge completed?",
				showCancelButton: true,
				confirmButtonText: "Yes",
				confirmButtonColor: "#e64942",
				cancelButtonText: "No",
				position: "center",
				showConfirmButton: true,
				timer: "",
				toast: false,
				cancelButtonColor: "#efefef",
			}).then((result) => {
				if (result.value) {
					this.completeRecharge();
				}
			});
		},

		completeRecharge() {
			this.getToken();
			this.completing = true;
			this.$axios
				.get("/staffs/rechargeComplete?device_id=" + this.deviceRenewalId, {
					headers: { Authorization: "Bearer " + this.token },
				})
				.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message, "success").then(() => {
							this.$router.push({ name: "requested_devices" });
						});
					} else {
						this.$swal("", response.data.message, "error");
					}
				})
				.catch((error) => {
					const msg = error?.response?.data?.message || "Something went wrong";
					this.$swal("", msg, "error");
				})
				.finally(() => {
					this.completing = false;
				});
		},

		submitUpdateExpiry() {
			this.errors = {};
			if (!this.deviceRenewalId) {
				this.$swal("", "Device renewal ID is missing", "error");
				return;
			}
			if (!this.deviceIccid) {
				this.$swal("", "ICCID is missing", "error");
				return;
			}
			if (!this.expiryDate) {
				this.errors.expiry_date = "Expiry date is required";
				return;
			}

			this.getToken();
			this.expirySubmitting = true;
			this.$axios
				.post(
					"/staffs/updateIccidExpiry",
					{
						device_id: this.deviceRenewalId,
						iccid: this.deviceIccid,
						date: this.expiryDate,
					},
					{ headers: { Authorization: "Bearer " + this.token } }
				)
				.then((response) => {
					const ok = response.data?.status === true || response.data?.status === "true";
					if (ok) {
						this.$swal("", response.data?.message || "Validity updated successfully", "success");
						this.fetchIccidDetails();
					} else {
						this.$swal("", response.data?.message || "Failed to update validity", "error");
					}
				})
				.catch((error) => {
					const fieldErrors = error?.response?.data?.errors;
					if (fieldErrors && typeof fieldErrors === "object") {
						Object.keys(fieldErrors).forEach((k) => {
							const v = fieldErrors[k];
							this.errors[k] = Array.isArray(v) ? v[0] : v;
						});
					}
					const msg = error?.response?.data?.message || "Something went wrong";
					this.$swal("", msg, "error");
				})
				.finally(() => {
					this.expirySubmitting = false;
				});
		},
	},
};
</script>
